import React, { Fragment, useEffect } from "react";
import Input from "../../../form/Input";
import useForm from "../../../../hooks/useForm";
import Button from "../../../form/Button";
import useMutation from "../../../../hooks/useMutation";
import { sendReminder } from "../../../../services/statusService";
import dayjs from "dayjs";
import { toast } from "react-toastify";

const validation = {
  email: [
    {
      type: "email",
      required: true,
      message: "Enter valid Email",
    },
  ],
};

const Reminder = ({ getResponse = () => {}, close = () => {}, data }) => {
  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    resetField,
    formValidate,
  } = useForm({ validationRules: validation });

  const today = dayjs();
  const oneMonthLater = today.add(1, "month");

  useEffect(() => {
    if (data?._id) {
      setFieldsValue({ email: data?.userDetails?.email });
    }
  }, [data]);

  const {
    mutate,
    error,
    isPending: isLoading,
  } = useMutation({
    mutationFn: async (val) => {
      return await sendReminder({
        ...val,
        custom_text: `Your application is incomplete. ${
          data?.deadLine
            ? `The final deadline is ${dayjs(data.deadLine).format(
                "DD MMM, YYYY"
              )}. Submit your complete application by the deadline to be considered.`
            : "Submit your complete application."
        }`,
        ids: [data?._id],
      });
    },
    onSuccess: (res) => {
      if (res?.status === 200 || res?.status === 201) {
        getResponse({ ...res, status: values?.status, id: data?._id });
        toast.success(res?.message);
        close();
      } else {
        toast.warning(res?.message);
      }
      return res;
    },
    onError: (error) => {
      console.log(error);
    },
  });

  return (
    <Fragment>
      {`Your application is incomplete. ${
        data?.deadLine
          ? `The final deadline is ${dayjs(data.deadLine).format(
              "DD MMM, YYYY"
            )}. Submit your complete application by the deadline to be considered.`
          : "Submit your complete application."
      }`}
      <form onSubmit={(e) => handleSubmit(e, mutate)} className="space-y-6">
        <div className="mt-4">
          <Input
            label={" Email"}
            inputType={"email"}
            value={values?.email}
            inputPlaceholder={"Enter Your Email"}
            inputName="email"
            onChange={handleChange}
            required={true}
            isValidate={true}
            {...formValidate(errors, "email")}
          />
        </div>

        <div className="flex items-center  gap-4 pt-8 justify-center">
          <div>
            <Button
              buttonLabel={"Sent"}
              buttonType="submit"
              buttonLabelClasses={"!text-sm"}
              // buttonIcon={"fa-light fa-floppy-disk"}
              // buttonIconPosition={"left"}
              buttonClasses="!py-3 !px-4 rounded-lg text-white !h-auto !bg-chestnut-rose hover:!bg-red-600 rounded-xl"
              {...(isLoading && {
                loading: true,
                buttonIconPosition: "left",
                isDisable: true,
              })}
            />
          </div>
          <div>
            <Button
              buttonLabel={"Close"}
              buttonLabelClasses={"!text-sm"}
              // buttonIcon={"fa-light fa-floppy-disk"}
              // buttonIconPosition={"left "}
              buttonClasses="rounded-xl bg-transparent !text-black border-chestnut-rose border-2 hover:bg-transparent"
              buttonFunction={close}
            />
          </div>
        </div>
      </form>
    </Fragment>
  );
};

export default Reminder;
